<template>
    <div class="push-menu-layer">
        <div class="nav-justified">
            <div class="scroll-gradient">
                <div class="scroll-area-lg">
                    <VuePerfectScrollbar class="scrollbar-container">
                        <div
                            class="vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
                        >
                            <template v-if="tasks && tasks.length > 0">
                                <template v-for="(task, idx) in tasks">
                                    <div
                                        v-if="tasks.length > 0"
                                        :key="idx"
                                        class="vertical-timeline-item vertical-timeline-element"
                                    >
                                        <div>
                                            <span
                                                class="vertical-timeline-element-icon bounce-in cursor-pointer"
                                                @click="
                                                    goPushPage(task.pageLink)
                                                "
                                            >
                                                <i
                                                    class="badge badge-dot badge-dot-xl badge-primary"
                                                ></i>
                                            </span>
                                            <div
                                                class="vertical-timeline-element-content bounce-in"
                                            >
                                                <!-- <span
                                                        class="deletePush"
                                                        @click="
                                                            deletePush(
                                                                task,
                                                            )
                                                        "
                                                        ><i
                                                            class="material-icons"
                                                            >close</i
                                                        ></span
                                                    > -->
                                                <h4 class="timeline-title">
                                                    <span
                                                        class="cursor-pointer"
                                                        @click="
                                                            toggleSubTitle(idx)
                                                        "
                                                        >{{ task.title }}</span
                                                    ><q-badge
                                                        rounded
                                                        class="q-ml-xs cursor-pointer"
                                                        color="success"
                                                        :label="task.cnt"
                                                        @click.native="
                                                            goPushPage(
                                                                task.pageLink,
                                                            )
                                                        "
                                                    />
                                                </h4>
                                                <p
                                                    v-show="isSubTitleOpen(idx)"
                                                    v-html="task.subTitle"
                                                ></p>
                                                <!-- <p
                                                        v-html="
                                                            replaceDate(
                                                                task.regDt,
                                                            )
                                                        "
                                                        @click="
                                                            goPushPage(
                                                                task.route,
                                                            )
                                                        "
                                                    ></p> -->
                                                <span
                                                    class="vertical-timeline-element-date"
                                                ></span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <div
                                    class="vertical-timeline-item vertical-timeline-element"
                                >
                                    <div>
                                        <span
                                            class="vertical-timeline-element-icon bounce-in"
                                        >
                                            <i
                                                class="badge badge-dot badge-dot-xl badge-danger"
                                            ></i>
                                        </span>
                                        <div
                                            class="vertical-timeline-element-content bounce-in"
                                        >
                                            <h4 class="timeline-title">
                                                알림이 없습니다.
                                            </h4>
                                            <span
                                                class="vertical-timeline-element-date"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </VuePerfectScrollbar>
                </div>
            </div>
        </div>
    </div>
    <!-- 버튼 영역 -->
    <!-- <div class="search-box-btn">
            <q-btn-group outline>
                <c-btn
                    label="알림 비우기"
                    icon="delete_forever"
                    color="red-5"
                    @btnClicked="deletePushAll"
                />
            </q-btn-group>
        </div> -->
</template>

<script>
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
    name: "push-pop",
    components: {
        VuePerfectScrollbar,
    },
    data() {
        return {
            tasks: [],
            taskUrl: "",
            openedSubTitles: {},
        };
    },
    computed: {},
    beforeCreate() {},
    created() {},
    beforeMount() {
        Object.assign(this.$data, this.$options.data());
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {},
    methods: {
        init() {
            this.editable = this.$route.meta.editable;
            this.taskUrl = selectConfig.com.task.url;
            this.getTask();
        },
        getTask() {
            this.$http.url = this.taskUrl;
            this.$http.type = "GET";
            this.$http.param = {
                userId: this.$store.getters.user.userId,
            };
            this.$http.request((_result) => {
                this.tasks = _result.data;
            });
        },
        goPushPage(_route) {
            this.$router.push(_route);
            this.$emit("closePopup");
        },
        toggleSubTitle(_idx) {
            this.$set(this.openedSubTitles, _idx, !this.openedSubTitles[_idx]);
        },
        isSubTitleOpen(_idx) {
            return !!this.openedSubTitles[_idx];
        },
        replaceDate(_date) {
            return _date.replace(".0", "");
        },
        deletePush(_push) {
            window.getApp.$emit("CONFIRM", {
                title: "확인",
                message: "알림을 삭제하시겠습니까?",
                type: "warning", // success / info / warning / error
                confirmCallback: () => {
                    this.$http.url = this.$format(
                        transactionConfig.sys.push.history.delete.url,
                        _push.pushMessageId,
                    );
                    this.$http.type = "DELETE";
                    this.$http.request(() => {
                        this.getTask();
                        window.getApp.$emit("APP_REQUEST_SUCCESS");
                    });
                },
                cancelCallback: () => {},
            });
        },
        deletePushAll() {
            window.getApp.$emit("CONFIRM", {
                title: "확인",
                message: "알림 전체를 삭제하시겠습니까?",
                type: "warning", // success / info / warning / error
                confirmCallback: () => {
                    this.$http.url = this.$format(
                        transactionConfig.sys.push.history.user.url,
                        this.$store.getters.user.userId,
                    );
                    this.$http.type = "DELETE";
                    this.$http.request(() => {
                        window.getApp.$emit("APP_REQUEST_SUCCESS");
                        this.$emit("closePopup");
                    });
                },
                cancelCallback: () => {},
            });
        },
    },
};
</script>

<style lang="sass">
.push-menu-layer
  .nav-justified
    padding: 10px
  .vertical-timeline-element-content
    p
      font-size: 1.1em !important
    .timeline-title
      font-size: 1.25em !important
  .deletePush
    width: 40px
    height: 40px
    margin: 0 auto
    float: right
    padding-right: 7px
    i
      font-size: 1.2em
      color: red
      font-weight: 600
</style>
